import {useContext} from 'react';
import {Context} from '../context';

export function useCart() {
  const {cart} = useContext(Context);
  return cart;
}